import ExpandableCustom from './expandable-custom.js';

const pluginName = 'expandableCustom';
const elements = '[data-expand-custom]';
const togglable = 'data-togglable';
const control = 'data-control';
const maxHeight = 'data-max-height';
const maxHeightMobile = 'data-max-height-mobile';
const text = 'data-text';
const textToggled = 'data-text-toggled';
const toggled = 'data-toggled';

export default {
    init() {
        $.fn[pluginName] = function() {
            return this.each((i, el) => {
                let expandable = new ExpandableCustom(
                    el,
                    $(el).attr(togglable),
                    $(el).attr(control),
                    $(el).attr(maxHeight),
                    $(el).attr(maxHeightMobile),
                    $(el).attr(text),
                    $(el).attr(textToggled),
                    $(el).attr(toggled)
                );
                expandable.init();
            });
        };

        $(document).ready(() => {
            $(elements)[pluginName]();
        });
    }
};
